import { AfterViewInit, Component, DestroyRef, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { TranslateService } from './reusables/i18n/translate';
import { Translation } from './data';


@Component({
    selector: 'app-root',
    imports: [RouterOutlet],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent implements AfterViewInit {

    /** Destroy ref. */
    private readonly _destroyRef: DestroyRef = inject(DestroyRef);

    /** Translate service. */
    private readonly _translate: TranslateService<Translation> = inject(TranslateService);

    /** Footer > legal notices element. */
    private _footerLegalNoticesElt: HTMLElement | null = document.getElementById('footerLegalNotices');

    /** Footer > cookies preferences. */
    private _footerCookiesPreferences: HTMLElement | null = document.getElementById('footerCookiesPreferences');

    /** Footer > copyright element. */
    private _footerCopyrightElt: HTMLElement | null = document.getElementById('footerCopyright');

    /** AfterViewInit. */
    ngAfterViewInit(): void {
        this._observeFooterTexts();
    }

    /**
     * Set footer texts.
     * This is due to the fact that footer is directly inside index.html.
     */
    private _observeFooterTexts(): void {
        // Legal notices.
        this._translate.getText$('FOOTER_LEGAL_NOTICES').pipe(takeUntilDestroyed(this._destroyRef)).subscribe({
            next: (text: string) => {
                this._footerLegalNoticesElt!.textContent = text;
            }
        });

        // Copyright.
        this._translate.getText$('COPYRIGHT').pipe(takeUntilDestroyed(this._destroyRef)).subscribe({
            next: (text: string) => {
                this._footerCopyrightElt!.textContent = text;
            }
        });

        // Cookies preferences.
        this._translate.getText$('FOOTER_COOKIES_PREFERENCES').pipe(takeUntilDestroyed(this._destroyRef)).subscribe({
            next: (text: string) => {
                this._footerCookiesPreferences!.textContent = text;
            }
        });
    }
}
